/*
 * Author: Roger
 * File Created: Thursday, 24-08-08 10:39 am
 * Last Modified: Tuesday, 24-08-20 05:15 pm, by Roger
 */

const Pay = () => {
  return (
    <svg fill="none" viewBox="0 0 81 80" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.9922 27.323V52.6123L29.5122 54.098H66.8082L70.5672 51.473L70.0684 27.323L66.3672 25.748H28.5672L26.9922 27.323Z"
        fill="#7E61F3"
      />
      <path
        d="M32.2991 9.99219H26.7183C26.1093 9.99219 25.6211 10.4857 25.6211 11.0894C25.6211 11.6932 26.1093 12.1867 26.7183 12.1867H32.2991C32.9081 12.1867 33.3963 11.6932 33.3963 11.0894C33.3963 10.4857 32.9081 9.99219 32.2991 9.99219Z"
        fill="white"
      />
      <path
        d="M66.3627 24.32H48.4077V10.2028C48.4077 7.33625 46.0767 5 43.205 5H14.8707C13.7 5 12.6342 5.40425 11.7627 6.05525C10.4975 7.0055 9.66797 8.50175 9.66797 10.1975V69.5908C9.66797 71.2918 10.4975 72.788 11.7627 73.7383C12.6342 74.3893 13.7 74.7935 14.8707 74.7935H43.205C46.0715 74.7935 48.4077 72.4625 48.4077 69.5908V55.4735H66.3627C69.2292 55.4735 71.5602 53.1425 71.5602 50.276V29.5175C71.5602 26.651 69.2292 24.32 66.3627 24.32ZM46.2132 63.6898V69.5908C46.2132 71.2445 44.864 72.5938 43.2102 72.5938H14.8655C14.246 72.5938 13.6685 72.4048 13.1855 72.0793C12.3875 71.5385 11.8572 70.625 11.8572 69.5855V10.2028C11.8572 9.1685 12.3822 8.24975 13.1855 7.709C13.6632 7.3835 14.2407 7.1945 14.8655 7.1945H43.205C44.864 7.1945 46.208 8.54375 46.208 10.1975V17.1748V24.3148H30.6102C27.7437 24.3148 25.4127 26.6458 25.4127 29.5123V50.2708C25.4127 53.1373 27.7437 55.4683 30.6102 55.4683H46.208V63.6845L46.2132 63.6898ZM66.3627 53.279H30.6102C28.9565 53.279 27.6072 51.9298 27.6072 50.276V37.4083H69.3605V50.276C69.3605 51.9298 68.0112 53.279 66.3575 53.279H66.3627ZM69.3657 31.1818H27.6072V29.5175C27.6072 27.8638 28.9565 26.5145 30.6102 26.5145H66.3575C68.0165 26.5145 69.3605 27.8638 69.3605 29.5175V31.1818H69.3657Z"
        fill="white"
      />
    </svg>
  );
};

export default Pay;
